import { render, staticRenderFns } from "./LogExtractionTab.vue?vue&type=template&id=ebebedd8&"
import script from "./LogExtractionTab.vue?vue&type=script&lang=js&"
export * from "./LogExtractionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports